module.exports = __webpack_public_path__ + "img/PL.1f9d98ad.svg";